
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import GhostCard from '@/components/GhostCard.vue'
import { Ghost } from '@/data/Ghosts'

@Options({
  components: { GhostCard }
})

export default class GhostPossibilities extends Vue {
  @Prop(Array) readonly evidence!: string[];
  @Prop(Object) readonly ghosts!: Ghost[];
}
